export default __webpack_public_path__ + "static/media/InsideGerms_00.cc64669a.png";